import { render, staticRenderFns } from "./new_invoice.vue?vue&type=template&id=dfe04c48&"
import script from "./new_invoice.vue?vue&type=script&lang=js&"
export * from "./new_invoice.vue?vue&type=script&lang=js&"
import style0 from "./new_invoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports